import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import { useAuth } from '../AuthProvider';
import './InterviewDetails.css';

const InterviewDetails = () => {
  const { user } = useAuth();
  const { interviewId } = useParams();
  const [interview, setInterview] = useState(null);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchInterviewDetails = async () => {
      try {
        if (user) {
          const token = await user.getIdToken();
          const response = await fetch(`http://localhost:4242/interview/${interviewId}`, {
            headers: {
              Authorization: `Bearer ${token}`,
            },
          });

          if (response.ok) {
            const data = await response.json();
            setInterview(data);
            console.log('Fetched interview details:', data); // Debugging log
          } else {
            const contentType = response.headers.get('content-type');
            if (contentType && contentType.includes('application/json')) {
              const errorData = await response.json();
              setError(`Failed to fetch interview details: ${errorData.error}`);
            } else {
              setError(`Failed to fetch interview details: ${response.statusText}`);
            }
          }
        } else {
          setError('User is not authenticated.');
        }
      } catch (err) {
        setError(`Error fetching interview details: ${err.message}`);
      }
    };

    fetchInterviewDetails();
  }, [user, interviewId]);

  if (error) {
    return <div className="error-message">{error}</div>;
  }

  if (!interview) {
    return <div>Loading...</div>;
  }

  let date;
  if (interview.date && interview.date._seconds) {
    date = new Date(interview.date._seconds * 1000);
  } else if (interview.date instanceof Date) {
    date = interview.date;
  } else if (typeof interview.date === 'string') {
    date = new Date(interview.date);
  } else {
    console.error('Unexpected date format:', interview.date);
    return <div className="error-message">Invalid date format</div>;
  }

  const optionsDate = {
    year: 'numeric',
    month: 'long',
    day: 'numeric',
    timeZone: 'America/New_York', // Adjust to your time zone
  };
  const optionsTime = {
    hour: 'numeric',
    minute: 'numeric',
    hour12: true,
    timeZone: 'America/New_York', // Adjust to your time zone
  };

  const formattedDate = new Intl.DateTimeFormat('en-US', optionsDate).format(date);
  const formattedTime = new Intl.DateTimeFormat('en-US', optionsTime).format(date);

  return (
    <div className="interview-details-container">
      <h2>Interview Details</h2>
      <p><strong>Date:</strong> {formattedDate}</p>
      <p><strong>Time:</strong> {formattedTime}</p>
      <p><strong>Behavioral Questions:</strong> {interview.behavioralQuestions || 'N/A'}</p>
      <p><strong>Technical Questions:</strong> {interview.technicalQuestions ? interview.technicalQuestions.join(', ') : 'N/A'}</p>
      <p><strong>Mode:</strong> {interview.mode || 'N/A'}</p>
      {interview.transcript ? (
        <>
          <p><strong>Transcript:</strong></p>
          <div className="transcript">
            {interview.transcript.map((entry, index) => (
              <div key={index} className={`transcript-entry ${entry.role}`}>
                <strong>{entry.role}:</strong> {entry.text}
              </div>
            ))}
          </div>
        </>
      ) : (
        <p>This interview doesn't have a transcript stored.</p>
      )}
      {interview.feedback ? (
        <>
          <p><strong>Feedback:</strong></p>
          <pre>{interview.feedback}</pre>
        </>
      ) : (
        <p>This interview doesn't have feedback stored.</p>
      )}
    </div>
  );
};

export default InterviewDetails;